import { render, staticRenderFns } from "./InspectionRequirements.vue?vue&type=template&id=629639e7&scoped=true&"
import script from "./InspectionRequirements.vue?vue&type=script&lang=js&"
export * from "./InspectionRequirements.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRequirements.vue?vue&type=style&index=0&id=629639e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629639e7",
  null
  
)

export default component.exports